var map = {
	"./category-icons/air-conditioning.svg": 31754,
	"./category-icons/architectural-services.svg": 93038,
	"./category-icons/bathrooms.svg": 37651,
	"./category-icons/bricklaying.svg": 9947,
	"./category-icons/building.svg": 47538,
	"./category-icons/carpentry-joinery.svg": 70149,
	"./category-icons/cleaning.svg": 71539,
	"./category-icons/conservatories.svg": 72655,
	"./category-icons/conversions.svg": 72545,
	"./category-icons/demolition.svg": 51336,
	"./category-icons/designing.svg": 62068,
	"./category-icons/doors-windows.svg": 49089,
	"./category-icons/drainage.svg": 73161,
	"./category-icons/driveways-paving.svg": 52548,
	"./category-icons/electrical.svg": 63160,
	"./category-icons/elevators-escalators-stairs.svg": 52302,
	"./category-icons/energy-efficiency.svg": 95464,
	"./category-icons/excavating-groundworks.svg": 40224,
	"./category-icons/extensions.svg": 14832,
	"./category-icons/fencing.svg": 84404,
	"./category-icons/fireplaces-chimneys.svg": 33275,
	"./category-icons/flooring.svg": 99068,
	"./category-icons/garagedoors-gates.svg": 37203,
	"./category-icons/gas-heating.svg": 21788,
	"./category-icons/handyman-services.svg": 80835,
	"./category-icons/heating-ventilation-airconditioning.svg": 39600,
	"./category-icons/insulation.svg": 97896,
	"./category-icons/kitchens.svg": 4841,
	"./category-icons/labouring.svg": 35001,
	"./category-icons/landscaping-gardening.svg": 31978,
	"./category-icons/locksmith.svg": 9992,
	"./category-icons/metal-structures.svg": 30002,
	"./category-icons/new-build.svg": 90851,
	"./category-icons/painting-decorating.svg": 803,
	"./category-icons/pest-control.svg": 84798,
	"./category-icons/planning.svg": 72009,
	"./category-icons/plastering-rendering-dry-walling.svg": 63589,
	"./category-icons/plastering.svg": 68193,
	"./category-icons/plumbing.svg": 76634,
	"./category-icons/property-renovation.svg": 88313,
	"./category-icons/propertyrepairs-maintenance.svg": 51739,
	"./category-icons/removals.svg": 10041,
	"./category-icons/renewable-energy.svg": 77814,
	"./category-icons/renovation.svg": 57493,
	"./category-icons/retrofitting.svg": 2419,
	"./category-icons/roofing.svg": 64248,
	"./category-icons/satellite-tv-aerial.svg": 53487,
	"./category-icons/scaffolding.svg": 56028,
	"./category-icons/security-alarm-cctv.svg": 38021,
	"./category-icons/shop-fitting.svg": 38436,
	"./category-icons/smart-home-systems.svg": 3414,
	"./category-icons/stoneworks.svg": 32521,
	"./category-icons/surveying.svg": 45060,
	"./category-icons/swimming-pools.svg": 5271,
	"./category-icons/tiling.svg": 34907,
	"./category-icons/tree-surgery.svg": 31804,
	"./category-icons/waste-removal.svg": 33987,
	"./category-icons/welding.svg": 81190,
	"./category-icons/window-coverings.svg": 91455,
	"./category-icons/windows-doors.svg": 74785,
	"./icons/ArrowLineRight.svg": 18262,
	"./icons/Bitmap.svg": 82286,
	"./icons/Commercial.svg": 49269,
	"./icons/CommercialIcon.svg": 52034,
	"./icons/Ellipse 285.svg": 13720,
	"./icons/PropertyPriceLastSoldValuation.svg": 17558,
	"./icons/Residential.svg": 76739,
	"./icons/Vector.svg": 5274,
	"./icons/a-payment-white.svg": 49861,
	"./icons/a-payment.svg": 12081,
	"./icons/accept-estimate-icon.svg": 92532,
	"./icons/account-active.svg": 74915,
	"./icons/account-circle.svg": 77197,
	"./icons/account-details-dark-icon.svg": 50576,
	"./icons/account-icon.svg": 21938,
	"./icons/account-inactive.svg": 95914,
	"./icons/account-progress-bar.svg": 98752,
	"./icons/account-starter-progress.svg": 72206,
	"./icons/account-step-check.svg": 32448,
	"./icons/account-step-complete-job.svg": 18515,
	"./icons/account-step-post.svg": 50638,
	"./icons/account-step-setup.svg": 93535,
	"./icons/account-type-icon.svg": 78417,
	"./icons/account.svg": 12064,
	"./icons/active-projects.svg": 40456,
	"./icons/add-avatar-icon.svg": 16300,
	"./icons/add-button-icon-yellow.svg": 46006,
	"./icons/add-button-icon.svg": 44769,
	"./icons/add-circle-yellow.svg": 37042,
	"./icons/add-icon-blue-2.svg": 24310,
	"./icons/add-icon-blue.svg": 83715,
	"./icons/add-logo.svg": 496,
	"./icons/add-new-skill.svg": 97069,
	"./icons/add-note-icon.svg": 48673,
	"./icons/add-person.svg": 15854,
	"./icons/add-profile.svg": 51360,
	"./icons/add-project-filled-icon.svg": 72965,
	"./icons/add-workspace.svg": 89236,
	"./icons/add.svg": 71480,
	"./icons/alert-box-red.svg": 81793,
	"./icons/all-jobs-filter.svg": 32560,
	"./icons/analytics-estimate.svg": 88880,
	"./icons/analyticsCustomerRating.svg": 18710,
	"./icons/analyticsEstimateSent.svg": 36773,
	"./icons/analyticsJobsCompleted.svg": 10928,
	"./icons/architecture-icon.svg": 15084,
	"./icons/archive-icon.svg": 35895,
	"./icons/arrow-collapse.svg": 6746,
	"./icons/arrow-down-icon.svg": 36531,
	"./icons/arrow-expand-more.svg": 53863,
	"./icons/arrow-left.svg": 65648,
	"./icons/arrow-right-yellow.svg": 46384,
	"./icons/arrow-right.svg": 76415,
	"./icons/arrow-up-icon.svg": 39954,
	"./icons/assign-member-icon.svg": 17755,
	"./icons/attach-pin.svg": 38010,
	"./icons/audit-icon.svg": 18534,
	"./icons/available.svg": 16588,
	"./icons/avatar-blue.svg": 63425,
	"./icons/avatar-tp-icon.svg": 43165,
	"./icons/awaiting-estimates-icon.svg": 12223,
	"./icons/back.svg": 79082,
	"./icons/background-wave.svg": 96471,
	"./icons/bath-icon.svg": 52678,
	"./icons/bed-icon.svg": 83490,
	"./icons/bell-icon.svg": 30414,
	"./icons/big-trash-icon.svg": 25992,
	"./icons/bike-ride-filled-icon.svg": 49654,
	"./icons/billing-icon.svg": 73618,
	"./icons/blue-check.svg": 16764,
	"./icons/blue-edit.svg": 50512,
	"./icons/blue-exclaimation.svg": 96136,
	"./icons/blue-money-out.svg": 35571,
	"./icons/blue-triangle.svg": 77200,
	"./icons/building-filled-icon.svg": 28942,
	"./icons/buildings-filled-icon.svg": 87395,
	"./icons/burger-menu.svg": 30220,
	"./icons/c-payment.svg": 60351,
	"./icons/calendar-2.svg": 10560,
	"./icons/calendar-delete-modal.svg": 91299,
	"./icons/calendar-delete.svg": 77351,
	"./icons/calendar-icon.svg": 85357,
	"./icons/calendar-instructions.svg": 37541,
	"./icons/calendar-modal-edit.svg": 59386,
	"./icons/calendar-modal-icon.svg": 71789,
	"./icons/calu-pen.svg": 41248,
	"./icons/camera.svg": 58854,
	"./icons/camera2.svg": 23752,
	"./icons/cancel-2.svg": 68620,
	"./icons/cancel.svg": 92045,
	"./icons/cancelled-icon.svg": 78610,
	"./icons/categories-icon.svg": 93327,
	"./icons/categories.svg": 70731,
	"./icons/certificate-filled-icon.svg": 47941,
	"./icons/certificate.svg": 62156,
	"./icons/chat-dark.svg": 94822,
	"./icons/chat-dox-white.svg": 92755,
	"./icons/chat-dox.svg": 48435,
	"./icons/chat-emoji-icon.svg": 68050,
	"./icons/chat-empty.svg": 49593,
	"./icons/chat-filter.svg": 79984,
	"./icons/chat-icon.svg": 62401,
	"./icons/chat-menu-icon.svg": 91191,
	"./icons/chat-mic-icon.svg": 74367,
	"./icons/chat-orange-send-icon.svg": 33551,
	"./icons/chat-vid-icon.svg": 54923,
	"./icons/chat.svg": 98701,
	"./icons/check-blue.svg": 13190,
	"./icons/check-mark-sucess.svg": 57848,
	"./icons/check.svg": 82497,
	"./icons/checked.svg": 49406,
	"./icons/cheveron-left.svg": 41845,
	"./icons/chevron-right.svg": 19501,
	"./icons/circle.svg": 77183,
	"./icons/circular-edit-pen-filled-blue.svg": 13053,
	"./icons/clip-icon.svg": 18241,
	"./icons/clock-2.svg": 5806,
	"./icons/clock-3.svg": 36799,
	"./icons/clock-icon.svg": 51663,
	"./icons/clock.svg": 92075,
	"./icons/clock_circle.svg": 37374,
	"./icons/close-2.svg": 51452,
	"./icons/collaboration-icon.svg": 45288,
	"./icons/comment.svg": 29886,
	"./icons/commercial-filter.svg": 5208,
	"./icons/commerical.svg": 13725,
	"./icons/company.svg": 92024,
	"./icons/complete-1.svg": 3560,
	"./icons/complete-project.svg": 15070,
	"./icons/complete-projects.svg": 44001,
	"./icons/complete.svg": 94618,
	"./icons/completed-filter.svg": 35273,
	"./icons/completed-icon.svg": 46932,
	"./icons/confirm-accept-job.svg": 75644,
	"./icons/confirm-accept-quote.svg": 67173,
	"./icons/confirm-estimate-icon.svg": 57270,
	"./icons/confirm-reject-quote.svg": 55648,
	"./icons/congratulations.svg": 67200,
	"./icons/connections-icon.svg": 42832,
	"./icons/connections.svg": 96486,
	"./icons/construction.svg": 37632,
	"./icons/copy-2.svg": 96037,
	"./icons/copy-3.svg": 41316,
	"./icons/copy.svg": 28552,
	"./icons/couch-filled-icon.svg": 12542,
	"./icons/courses-hero-image-2.svg": 69313,
	"./icons/create-new-folder-icon.svg": 41539,
	"./icons/create-plus.svg": 18228,
	"./icons/create-task-icon.svg": 70703,
	"./icons/cross-icon.svg": 11449,
	"./icons/cursor.svg": 51849,
	"./icons/curve-arrow.svg": 25796,
	"./icons/custom-loader.svg": 28878,
	"./icons/dark-filled-home-icon.svg": 18146,
	"./icons/dashboard-menu-icon.svg": 53839,
	"./icons/dashboard-no-chat.svg": 60114,
	"./icons/dashboard-no-mentions.svg": 19489,
	"./icons/dashboard-no-projects.svg": 18974,
	"./icons/dashboard-no-transactions.svg": 55019,
	"./icons/dashboard.svg": 17461,
	"./icons/date-icon.svg": 46123,
	"./icons/date.svg": 33463,
	"./icons/day-rate.svg": 83658,
	"./icons/deactivate-icon-2.svg": 26792,
	"./icons/deactivate-icon.svg": 34721,
	"./icons/decrement.svg": 13034,
	"./icons/delete-icon-white.svg": 66876,
	"./icons/delete-icon.svg": 2668,
	"./icons/delete-solid.svg": 10352,
	"./icons/delete-stage-icon.svg": 27143,
	"./icons/delete.svg": 90930,
	"./icons/description-calendar.svg": 45866,
	"./icons/details-menu-icon.svg": 48933,
	"./icons/distance.svg": 9626,
	"./icons/document-icon.svg": 41274,
	"./icons/document.svg": 152,
	"./icons/documents.svg": 19243,
	"./icons/done.svg": 56903,
	"./icons/dots.svg": 48999,
	"./icons/down-arrow.svg": 5743,
	"./icons/download-icon.svg": 94971,
	"./icons/download-yellow-filled-icon.svg": 79273,
	"./icons/downloads.svg": 19382,
	"./icons/draft-icon.svg": 3050,
	"./icons/draft-project.svg": 20860,
	"./icons/draft-projects.svg": 12631,
	"./icons/drive-ways-icon.svg": 94636,
	"./icons/driveways-and-paving.svg": 69245,
	"./icons/driveways.svg": 29241,
	"./icons/dual-message.svg": 19227,
	"./icons/dudley-college-icon.svg": 80710,
	"./icons/duration-filled-icon.svg": 14054,
	"./icons/earnings-icon.svg": 5032,
	"./icons/edit-chat-2.svg": 61003,
	"./icons/edit-chat.svg": 90666,
	"./icons/edit-pen-icon.svg": 31549,
	"./icons/edit-pen-yellow-filled-icon.svg": 30623,
	"./icons/electrical.svg": 4405,
	"./icons/electricalChart copy.svg": 34278,
	"./icons/electricalChart.svg": 18571,
	"./icons/email-sent.svg": 49704,
	"./icons/emergency-callout.svg": 87069,
	"./icons/emergency-filter.svg": 89473,
	"./icons/emergency-watch.svg": 41356,
	"./icons/emoji.svg": 37795,
	"./icons/empty-accreditations-icon.svg": 72388,
	"./icons/empty-calendar-icon.svg": 48705,
	"./icons/empty-description-icon.svg": 23287,
	"./icons/empty-expertise-icon.svg": 21582,
	"./icons/empty-files-folder-icon.svg": 19621,
	"./icons/empty-gallery-icon.svg": 78571,
	"./icons/empty-insurance-icon.svg": 98777,
	"./icons/empty-notif.svg": 98087,
	"./icons/empty-project-icon.svg": 40196,
	"./icons/empty-templates-icon.svg": 37002,
	"./icons/empty-transaction-list.svg": 60834,
	"./icons/empty-workstation.svg": 26636,
	"./icons/energy.svg": 64539,
	"./icons/escrow-wallet-icon.svg": 63762,
	"./icons/estimate-icon.svg": 73117,
	"./icons/estimate-loader.svg": 40007,
	"./icons/estimate-sent-filter.svg": 17963,
	"./icons/estimate-tab.svg": 44379,
	"./icons/estimate.svg": 10009,
	"./icons/estimates-receive-icon.svg": 76502,
	"./icons/estimates-received.svg": 71424,
	"./icons/estimates-sent-icon.svg": 76135,
	"./icons/exclaimation-icon.svg": 36827,
	"./icons/exclaimation-mark.svg": 48539,
	"./icons/exclaimation.svg": 20647,
	"./icons/external_contractor.svg": 39324,
	"./icons/face.svg": 55176,
	"./icons/file-upload-icon.svg": 29925,
	"./icons/file-upload.svg": 65713,
	"./icons/filled-blue-folder-icon.svg": 58745,
	"./icons/filled-calendar-icon.svg": 78316,
	"./icons/filled-details-icon.svg": 52172,
	"./icons/filled-download-icon.svg": 34882,
	"./icons/filled-edit-icon.svg": 65110,
	"./icons/filled-gray-folder-icon.svg": 40924,
	"./icons/filled-image-icon.svg": 34699,
	"./icons/filled-move-icon.svg": 75547,
	"./icons/filled-share-icon.svg": 37581,
	"./icons/filled-sort-icon.svg": 29086,
	"./icons/filter-icon-2.svg": 73716,
	"./icons/filter-icon.svg": 92069,
	"./icons/filter.svg": 87985,
	"./icons/finance-icon.svg": 72207,
	"./icons/finance.svg": 98475,
	"./icons/floors.svg": 7906,
	"./icons/folder-yellow-icon.svg": 16598,
	"./icons/folder.svg": 30811,
	"./icons/footer-menu-chat-icon.svg": 39249,
	"./icons/footer-menu-chat.svg": 87037,
	"./icons/footer-menu-dashboard-icon.svg": 53769,
	"./icons/footer-menu-find-icon.svg": 54948,
	"./icons/footer-menu-find-jobs.svg": 51523,
	"./icons/footer-menu-hamburger.svg": 18764,
	"./icons/footer-menu-home.svg": 52526,
	"./icons/footer-menu-project.svg": 30198,
	"./icons/footer-menu-projects-icon.svg": 33165,
	"./icons/footer-menu-quotes.svg": 95256,
	"./icons/footer-menu-search.svg": 78567,
	"./icons/footer-menu-workspace.svg": 67566,
	"./icons/free-member-bg-white.svg": 70696,
	"./icons/free-member-blue.svg": 9441,
	"./icons/g-payment.svg": 15667,
	"./icons/gallery.svg": 61691,
	"./icons/gas-icon.svg": 54100,
	"./icons/gas.svg": 22506,
	"./icons/gasChart.svg": 72446,
	"./icons/gbp-currency.svg": 28940,
	"./icons/graduation-hat.svg": 38935,
	"./icons/green-check.svg": 20083,
	"./icons/green-double-tick.svg": 30148,
	"./icons/green-star-circle.svg": 56886,
	"./icons/group-chat-icon.svg": 33647,
	"./icons/hand-icon-check.svg": 29981,
	"./icons/handyman-services.svg": 32012,
	"./icons/heart-icon.svg": 56233,
	"./icons/heart.svg": 49733,
	"./icons/heating.svg": 66835,
	"./icons/hide-icon.svg": 49991,
	"./icons/historic_project_icon.svg": 71974,
	"./icons/home-filled-icon-2.svg": 38410,
	"./icons/home-filled-icon.svg": 92079,
	"./icons/home-icon.svg": 56,
	"./icons/home-yellow-filled-icon.svg": 69238,
	"./icons/home.svg": 74174,
	"./icons/hourly-rate.svg": 10491,
	"./icons/house-bg-icon.svg": 99127,
	"./icons/house-icon.svg": 78457,
	"./icons/house.svg": 58901,
	"./icons/houses.svg": 16060,
	"./icons/id-check.svg": 97383,
	"./icons/id-not-verified.svg": 17101,
	"./icons/idea-icon.svg": 48860,
	"./icons/iknowa-initials-logo.svg": 2356,
	"./icons/iknowa-invoice-logo.svg": 95380,
	"./icons/iknowa-logo-2.svg": 5099,
	"./icons/iknowa-logo.svg": 91594,
	"./icons/image-attachment.svg": 27220,
	"./icons/image-file-icon.svg": 58073,
	"./icons/image-icon.svg": 11500,
	"./icons/image_placeholder.svg": 38456,
	"./icons/imagefile-icon.svg": 21730,
	"./icons/in-progress-filter.svg": 14729,
	"./icons/in-progress-icon.svg": 39828,
	"./icons/in-progress-setting.svg": 64301,
	"./icons/in-progress-white.svg": 90950,
	"./icons/in-progress.svg": 64842,
	"./icons/incomplete.svg": 74371,
	"./icons/increment.svg": 31374,
	"./icons/info-alert.svg": 90038,
	"./icons/info-black.svg": 89389,
	"./icons/info-grey.svg": 49301,
	"./icons/info-icon-transparent.svg": 39070,
	"./icons/info-icon.svg": 96999,
	"./icons/info-orange.svg": 55570,
	"./icons/info-outline.svg": 36534,
	"./icons/info.svg": 36947,
	"./icons/insulation.svg": 3993,
	"./icons/insulationChart.svg": 15839,
	"./icons/insurance-file-icon.svg": 48502,
	"./icons/insurance-icon.svg": 88733,
	"./icons/insurance.svg": 43961,
	"./icons/intercom.svg": 30250,
	"./icons/interest-card-confirmation-icon.svg": 75668,
	"./icons/interest-card-thanyou-icon.svg": 69465,
	"./icons/invite-icon.svg": 11630,
	"./icons/invite-sent-member.svg": 20182,
	"./icons/invite.svg": 90764,
	"./icons/invites-pending-icon.svg": 76909,
	"./icons/invoice.svg": 98292,
	"./icons/issue-raise.svg": 55167,
	"./icons/job-client-empty-icon.svg": 77926,
	"./icons/jobService.svg": 14713,
	"./icons/key-filled-icon.svg": 47609,
	"./icons/krystal-blue.svg": 59220,
	"./icons/krystal-icon.svg": 63795,
	"./icons/krystal.svg": 10479,
	"./icons/kyp-icon.svg": 24785,
	"./icons/kyp-icons/air-source-icon.svg": 33869,
	"./icons/kyp-icons/boundery-icon.svg": 57453,
	"./icons/kyp-icons/devices-icon.svg": 93338,
	"./icons/kyp-icons/epc-icon.svg": 39887,
	"./icons/kyp-icons/floor-plan-icon.svg": 79229,
	"./icons/kyp-icons/fuse-box-icon.svg": 68594,
	"./icons/kyp-icons/insurance-icon-2.svg": 85224,
	"./icons/kyp-icons/living-room-icon.svg": 49474,
	"./icons/kyp-icons/planning-icon.svg": 7982,
	"./icons/kyp-icons/propertree-icon.svg": 2141,
	"./icons/kyp-icons/score-icon.svg": 26491,
	"./icons/kyp-icons/solar-pv-icon.svg": 50857,
	"./icons/kyp-icons/title-deeds-icon.svg": 26297,
	"./icons/kyp-icons/valuation-icon.svg": 54570,
	"./icons/leave-estimate-icon.svg": 23527,
	"./icons/leave-page-icon.svg": 22114,
	"./icons/left-chevron.svg": 71786,
	"./icons/lens.svg": 48091,
	"./icons/lighting.svg": 63719,
	"./icons/lines.svg": 1496,
	"./icons/list-and-pen.svg": 17493,
	"./icons/list-view-dark-icon.svg": 12922,
	"./icons/load-icon.svg": 20587,
	"./icons/load-template-icon.svg": 57056,
	"./icons/location-filled-icon.svg": 47687,
	"./icons/lock.svg": 45482,
	"./icons/lockicon.svg": 42761,
	"./icons/logout.svg": 34277,
	"./icons/manage-documents-filled-icon.svg": 51978,
	"./icons/map-marker.svg": 86054,
	"./icons/map-view-dark-icon.svg": 63114,
	"./icons/map.svg": 59543,
	"./icons/market-history-icon.svg": 81538,
	"./icons/master-card-icon.svg": 59214,
	"./icons/measure.svg": 27633,
	"./icons/members-icon.svg": 42582,
	"./icons/mention.svg": 83395,
	"./icons/menu-close.svg": 38333,
	"./icons/menu.svg": 72434,
	"./icons/message-chat.svg": 18987,
	"./icons/message-icon.svg": 70170,
	"./icons/messages-add-video-icon.svg": 79923,
	"./icons/messages-files-icon.svg": 89685,
	"./icons/messages-icon.svg": 61775,
	"./icons/messages-white.svg": 92539,
	"./icons/messages.svg": 11979,
	"./icons/meter.svg": 72690,
	"./icons/mic-filled-icon.svg": 3893,
	"./icons/microphone-2.svg": 11522,
	"./icons/microphone.svg": 26007,
	"./icons/model_training_black.svg": 79579,
	"./icons/money-card.svg": 45392,
	"./icons/more-dots.svg": 97677,
	"./icons/more-icon.svg": 4646,
	"./icons/move-left.svg": 17818,
	"./icons/move-right.svg": 13265,
	"./icons/my-document.svg": 34657,
	"./icons/my-project.svg": 42989,
	"./icons/network-icon.svg": 75263,
	"./icons/new-chat-close-icon.svg": 40433,
	"./icons/new-icon.svg": 44155,
	"./icons/new-sort-icon.svg": 95614,
	"./icons/news.svg": 8566,
	"./icons/no-attachments-icon.svg": 43043,
	"./icons/no-document-icon.svg": 33498,
	"./icons/no-members-icon.svg": 40182,
	"./icons/not-added.svg": 95747,
	"./icons/not-started-filter.svg": 98493,
	"./icons/not-started-icon.svg": 50552,
	"./icons/not-started.svg": 82558,
	"./icons/not-verified-icon.svg": 17399,
	"./icons/note-pen.svg": 66421,
	"./icons/notepad.svg": 41034,
	"./icons/notification-bell.svg": 3096,
	"./icons/notification-status-dot.svg": 77383,
	"./icons/notifications-icon.svg": 68317,
	"./icons/opportunities-icon.svg": 90412,
	"./icons/orange-calendar.svg": 52368,
	"./icons/pad-pen.svg": 11716,
	"./icons/painting.svg": 80331,
	"./icons/pause.svg": 51947,
	"./icons/payment-notification-icon.svg": 36905,
	"./icons/payment-success.svg": 33465,
	"./icons/pdf-document-icon.svg": 51131,
	"./icons/pdf-icon-sample.svg": 98654,
	"./icons/pdf-icon.svg": 57447,
	"./icons/pdficon.svg": 94676,
	"./icons/pen-filled-icon.svg": 50349,
	"./icons/pen-filled-yellow-icon.svg": 38776,
	"./icons/pencil-circle-blue.svg": 418,
	"./icons/pending-icon-dark.svg": 82555,
	"./icons/pending-icon.svg": 15994,
	"./icons/pending.svg": 87352,
	"./icons/personal-calendar-2.svg": 67527,
	"./icons/personal-calendar.svg": 82126,
	"./icons/phone-filled-icon.svg": 60356,
	"./icons/photo-placeholder.svg": 26945,
	"./icons/pie-with-circle.svg": 93385,
	"./icons/pin-location-blue.svg": 88513,
	"./icons/pin-location.svg": 30032,
	"./icons/plus-circle.svg": 68648,
	"./icons/popup-calender-calender.svg": 893,
	"./icons/popup-calender-clock.svg": 61323,
	"./icons/post-project-2.svg": 30304,
	"./icons/post-project-confirmation-icon.svg": 43277,
	"./icons/post-project.svg": 73961,
	"./icons/pound-circle.svg": 91072,
	"./icons/preferred-contractors-empty.svg": 46397,
	"./icons/prefix.svg": 83375,
	"./icons/premium-bg-white.svg": 65334,
	"./icons/premium-filter.svg": 62557,
	"./icons/premium-plan.svg": 86438,
	"./icons/profile-banner.svg": 20197,
	"./icons/profile-no-content-icon.svg": 1248,
	"./icons/profile-visit-icon.svg": 63686,
	"./icons/project-banner-icon.svg": 62129,
	"./icons/project-icon.svg": 15248,
	"./icons/project-insurance-guard-icon.svg": 49881,
	"./icons/project-logs-sidebar/calculator-and-pen.svg": 63530,
	"./icons/project-logs-sidebar/list-and-pen.svg": 99834,
	"./icons/project-notification-icon.svg": 33948,
	"./icons/project-owner-active.svg": 12399,
	"./icons/project-owner-inactive.svg": 60222,
	"./icons/project-post.svg": 24437,
	"./icons/project-progress-bar.svg": 14618,
	"./icons/project-status.svg": 36106,
	"./icons/project-thumbnail-icon.svg": 96761,
	"./icons/projects-filled-icon.svg": 70980,
	"./icons/promise-money-logo.svg": 20815,
	"./icons/properties-add-property.svg": 94296,
	"./icons/properties-icon.svg": 69130,
	"./icons/properties-my-property.svg": 10835,
	"./icons/properties-occupier.svg": 61011,
	"./icons/properties-owner.svg": 95526,
	"./icons/property-green.svg": 58366,
	"./icons/property-insurance-icon.svg": 79299,
	"./icons/property-lightgreen.svg": 50052,
	"./icons/property-listing-bath.svg": 54379,
	"./icons/property-listing-bed.svg": 47317,
	"./icons/property-listing-calender.svg": 33142,
	"./icons/property-listing-grid.svg": 35632,
	"./icons/property-listing-location.svg": 79605,
	"./icons/property-listing-sofa.svg": 2261,
	"./icons/property-orange.svg": 78659,
	"./icons/property-red.svg": 40990,
	"./icons/property-white-green.svg": 25358,
	"./icons/propety-data-tab/comparable-icon.svg": 5131,
	"./icons/propety-data-tab/legal-icon.svg": 58141,
	"./icons/propety-data-tab/market-history-icon.svg": 14473,
	"./icons/propety-data-tab/members-icon.svg": 46771,
	"./icons/propety-data-tab/my-document.svg": 85242,
	"./icons/propety-data-tab/projects-filled-icon.svg": 56009,
	"./icons/propety-data-tab/property-data-icon.svg": 53484,
	"./icons/propety-data-tab/property-map-icon.svg": 68770,
	"./icons/question-info.svg": 40720,
	"./icons/quote-notification-icon.svg": 42639,
	"./icons/quotes.svg": 70984,
	"./icons/range-icon.svg": 44020,
	"./icons/rating-star.svg": 52306,
	"./icons/received-request.svg": 14498,
	"./icons/recent-files-pdf-icon.svg": 89265,
	"./icons/reception-icon.svg": 40064,
	"./icons/recommendation-icons/home-rounded-square-yellow.svg": 96830,
	"./icons/recommendation-icons/speedometer-rounded-square-violet.svg": 24145,
	"./icons/recommendation-icons/tp-rounded-square-olive.svg": 44844,
	"./icons/red-exclaimation.svg": 61109,
	"./icons/refresh-2.svg": 88765,
	"./icons/reject-estimate-icon.svg": 70825,
	"./icons/rejected-filter.svg": 26767,
	"./icons/rejected-icon.svg": 95357,
	"./icons/rejected.svg": 25433,
	"./icons/remove-black.svg": 43285,
	"./icons/requests-icon.svg": 14849,
	"./icons/requests.svg": 10829,
	"./icons/residential-filter.svg": 56394,
	"./icons/residentialIcon.svg": 53892,
	"./icons/revenueOverview.svg": 67272,
	"./icons/revenuePerformance.svg": 769,
	"./icons/revenueService.svg": 14702,
	"./icons/right-arrow.svg": 14263,
	"./icons/right-chevron.svg": 79765,
	"./icons/roof.svg": 36977,
	"./icons/routine-filter.svg": 9216,
	"./icons/sample-skill-icon.svg": 46469,
	"./icons/save-draft-icon.svg": 80844,
	"./icons/save.svg": 44660,
	"./icons/schedule-icon.svg": 31298,
	"./icons/search-icon.svg": 35691,
	"./icons/search.svg": 64343,
	"./icons/security-icon.svg": 47569,
	"./icons/security-light-icon.svg": 45904,
	"./icons/send-2.svg": 59704,
	"./icons/send-invite-icon.svg": 87485,
	"./icons/send-message.svg": 78683,
	"./icons/send.svg": 46385,
	"./icons/sent-request.svg": 26709,
	"./icons/services-billing-icon.svg": 8425,
	"./icons/services-icon.svg": 3239,
	"./icons/services-members-icon.svg": 45337,
	"./icons/services-projects-icon.svg": 68732,
	"./icons/services-storage-icon.svg": 47475,
	"./icons/services-transaction-icon.svg": 56198,
	"./icons/settings.svg": 20716,
	"./icons/shape.svg": 49582,
	"./icons/share-icon.svg": 98934,
	"./icons/sidebar-icons/analytics.svg": 43013,
	"./icons/sidebar-icons/calendar.svg": 25337,
	"./icons/sidebar-icons/chat.svg": 6045,
	"./icons/sidebar-icons/client.svg": 25654,
	"./icons/sidebar-icons/clock_circle.svg": 1038,
	"./icons/sidebar-icons/connections.svg": 95638,
	"./icons/sidebar-icons/courses.svg": 10919,
	"./icons/sidebar-icons/dashboard.svg": 67109,
	"./icons/sidebar-icons/documents.svg": 11675,
	"./icons/sidebar-icons/eWallet.svg": 94419,
	"./icons/sidebar-icons/issue.svg": 27828,
	"./icons/sidebar-icons/jobs.svg": 5611,
	"./icons/sidebar-icons/members.svg": 52596,
	"./icons/sidebar-icons/menu.svg": 59970,
	"./icons/sidebar-icons/projects.svg": 95305,
	"./icons/sidebar-icons/property.svg": 82252,
	"./icons/sidebar-icons/trade-passport.svg": 79070,
	"./icons/sidebar-toggle-close.svg": 31822,
	"./icons/sidebar-toggle-open.svg": 35651,
	"./icons/single-chat-icon.svg": 69924,
	"./icons/sitevisitemptystate.svg": 67869,
	"./icons/skeleton-home-filled-icon.svg": 23187,
	"./icons/solar-icon.svg": 65008,
	"./icons/solar.svg": 82566,
	"./icons/sole-trader-icon-light.svg": 31430,
	"./icons/sort-asc.svg": 88051,
	"./icons/sort-desc.svg": 1419,
	"./icons/sort-icon.svg": 76699,
	"./icons/sort-triangle.svg": 83092,
	"./icons/sort.svg": 12871,
	"./icons/specialism-house.svg": 91814,
	"./icons/specialism-info.svg": 74062,
	"./icons/specialism-krystal.svg": 39052,
	"./icons/standard-filter.svg": 35279,
	"./icons/star-icon.svg": 48243,
	"./icons/status-emergency-icon.svg": 18717,
	"./icons/status-emergency.svg": 33561,
	"./icons/status-flexible-icon.svg": 85587,
	"./icons/status-not-started.svg": 81261,
	"./icons/status-out-of-hours.svg": 98342,
	"./icons/status-routine-blue.svg": 88159,
	"./icons/status-routine-icon.svg": 30408,
	"./icons/status-schedule-icon.svg": 98033,
	"./icons/status-standard-icon.svg": 24173,
	"./icons/storage-icon.svg": 32944,
	"./icons/submit-estimate-icon.svg": 59120,
	"./icons/submitting-estimate.svg": 75406,
	"./icons/subscription-icon.svg": 48386,
	"./icons/subscription-light-icon.svg": 39455,
	"./icons/team-performance-empty-screen.svg": 91422,
	"./icons/teamPerformance.svg": 47682,
	"./icons/template-icon-2.svg": 75280,
	"./icons/template-icon.svg": 92185,
	"./icons/tick-circle.svg": 78181,
	"./icons/tick.svg": 16920,
	"./icons/tile-view-dark-icon.svg": 84570,
	"./icons/timeline-icon.svg": 91352,
	"./icons/toggle-mobile-close-fullview.svg": 23614,
	"./icons/toggle-mobile-open-fullview.svg": 56880,
	"./icons/tools-bag-icon.svg": 95385,
	"./icons/tools-bg-icon.svg": 31626,
	"./icons/tools-icon.svg": 57826,
	"./icons/tools.svg": 46448,
	"./icons/tooltip.svg": 93356,
	"./icons/tp-icon.svg": 88251,
	"./icons/trade-network-currency.svg": 70910,
	"./icons/trade-network-list.svg": 10095,
	"./icons/trade-network-location.svg": 47758,
	"./icons/trade-network-prize.svg": 40993,
	"./icons/trade-network-right-left-arrow.svg": 66011,
	"./icons/trade-network-search.svg": 68335,
	"./icons/trade-network-sort.svg": 26303,
	"./icons/trade-network-trader.svg": 16535,
	"./icons/tradesperson-active.svg": 46256,
	"./icons/tradesperson-inactive.svg": 22921,
	"./icons/transaction-icon-1.svg": 43739,
	"./icons/transaction-icon-2.svg": 62376,
	"./icons/transaction-icon-3.svg": 27769,
	"./icons/transaction-successful.svg": 5588,
	"./icons/trash-filled.svg": 24836,
	"./icons/trash-icon.svg": 44927,
	"./icons/trash.svg": 36891,
	"./icons/triangle.svg": 11907,
	"./icons/unverified-icon.svg": 53404,
	"./icons/updated.svg": 37004,
	"./icons/upgrade-premium-yellow.svg": 41910,
	"./icons/upload-banner-icon.svg": 98183,
	"./icons/upload-group-icon.svg": 19196,
	"./icons/upload-icon.svg": 71722,
	"./icons/upload-image-icon.svg": 53206,
	"./icons/upload-image.svg": 65700,
	"./icons/upload-img.svg": 5322,
	"./icons/uploaded-image.svg": 2947,
	"./icons/user-build-profile.svg": 42209,
	"./icons/user-icon.svg": 7604,
	"./icons/user-identification-1.svg": 18671,
	"./icons/user-identification-2.svg": 55996,
	"./icons/user-identification-3.svg": 10269,
	"./icons/user-identification-arrow-right.svg": 41904,
	"./icons/user-plus.svg": 9171,
	"./icons/user-refer-and-earn.svg": 46958,
	"./icons/user-tie.svg": 59175,
	"./icons/user.svg": 10698,
	"./icons/utility-icon.svg": 76357,
	"./icons/ventilation.svg": 37524,
	"./icons/verified-icon.svg": 13383,
	"./icons/verified.svg": 25523,
	"./icons/verifying.svg": 51200,
	"./icons/video-consult-icon.svg": 31787,
	"./icons/video-filter.svg": 28555,
	"./icons/video-icon.svg": 84370,
	"./icons/view-icon.svg": 25342,
	"./icons/view-image-icon.svg": 794,
	"./icons/view-members-icon.svg": 40268,
	"./icons/view-note-icon.svg": 59170,
	"./icons/visa-icon.svg": 48718,
	"./icons/volume-high.svg": 30297,
	"./icons/wallet-card-circle-bg-1.svg": 35598,
	"./icons/wallet-card-circle-bg-2.svg": 29965,
	"./icons/wallet-card-circle-bg-3.svg": 94508,
	"./icons/wallet-card-circle-bg.svg": 27168,
	"./icons/wallet-card-logo.svg": 37545,
	"./icons/wallet-find-a-project.svg": 64438,
	"./icons/wallet.svg": 56736,
	"./icons/walls.svg": 13786,
	"./icons/warning-icon.svg": 12517,
	"./icons/warning-red-icon.svg": 29319,
	"./icons/warranty-insurance-icon.svg": 45994,
	"./icons/watch.svg": 63708,
	"./icons/white-check.svg": 41533,
	"./icons/white-exclaimation.svg": 71091,
	"./icons/white-filled-estimates-icon.svg": 38869,
	"./icons/white-filled-home-icon.svg": 8549,
	"./icons/white-filled-in-progress-icon.svg": 82779,
	"./icons/white-person.svg": 31512,
	"./icons/white-watch.svg": 30016,
	"./icons/windows.svg": 11986,
	"./icons/windowsChart.svg": 17766,
	"./icons/windowsIcon.svg": 85185,
	"./icons/withdraw-icon.svg": 19541,
	"./icons/workspace-logo-two.svg": 42075,
	"./icons/workspace-logo.svg": 64798,
	"./icons/workspace.svg": 92478,
	"./icons/x.svg": 99897,
	"./icons/yellow-building-filled-icon.svg": 38649,
	"./icons/yellow-calendar-icon.svg": 24076,
	"./icons/yellow-certificate-icon.svg": 4393,
	"./icons/yellow-domain-icon.svg": 53870,
	"./icons/yellow-duration-icon.svg": 86674,
	"./icons/yellow-edit-icon.svg": 29718,
	"./icons/yellow-filled-not-started-icon.svg": 470,
	"./icons/yellow-location-icon.svg": 73689,
	"./icons/yellow-mic-icon.svg": 28637,
	"./icons/yellow-share-avatar-icon.svg": 33813,
	"./icons/yellow-share-icon.svg": 88621,
	"./icons/yellow-shield-icon.svg": 4903,
	"./icons/yellow-success-icon.svg": 28277,
	"./icons/yellow-trash-icon.svg": 75600,
	"./icons/yellow-watch.svg": 62249,
	"./icons/zoom.svg": 42226,
	"./images/account-detail-step1.svg": 72658,
	"./images/account-detail-step2.svg": 61345,
	"./images/account-detail-step3.svg": 70224,
	"./images/account-detail-step4.svg": 80367,
	"./images/badge.svg": 70828,
	"./images/banner-background-bottom.svg": 37806,
	"./images/blue-circle-outline.svg": 14545,
	"./images/builder-white.svg": 61148,
	"./images/builder.svg": 98028,
	"./images/business.svg": 29189,
	"./images/card-home-icon.svg": 95067,
	"./images/card-home-key-icon.svg": 20225,
	"./images/card-tool-icon.svg": 8766,
	"./images/card-tools-icon.svg": 11499,
	"./images/check-circle.svg": 24214,
	"./images/circle-construction.svg": 26551,
	"./images/circle-money.svg": 59428,
	"./images/client-empty-screen.svg": 92207,
	"./images/clock.svg": 60371,
	"./images/close-icon.svg": 99129,
	"./images/close.svg": 7733,
	"./images/copydata-folder.svg": 24281,
	"./images/courses-hero-image.svg": 28916,
	"./images/earn-credit-thumbnail.svg": 4986,
	"./images/electrician.svg": 60582,
	"./images/empty-gallery.svg": 28239,
	"./images/empty-screen.svg": 50259,
	"./images/empty-state-wallet-image.svg": 52100,
	"./images/empty_escrow.svg": 66688,
	"./images/events-hero-image.svg": 41149,
	"./images/filled-marker-icon-svg.svg": 75745,
	"./images/folder-import.svg": 21723,
	"./images/gas.svg": 73218,
	"./images/hands.svg": 27919,
	"./images/identity.svg": 68709,
	"./images/iknowa-logo.svg": 17762,
	"./images/iknowa-setting.svg": 3189,
	"./images/iknowa_logo.svg": 29964,
	"./images/image.svg": 26794,
	"./images/info-icon-blue.svg": 61140,
	"./images/info-icon.svg": 14927,
	"./images/inprogress.svg": 40975,
	"./images/krystal-purple.svg": 47446,
	"./images/krystal.svg": 59831,
	"./images/kyp-chart.svg": 71662,
	"./images/kyp-report.svg": 37836,
	"./images/location.svg": 62254,
	"./images/loginRightView.svg": 7639,
	"./images/logo-beta.svg": 65321,
	"./images/logo/app-iknowa-logo.svg": 6554,
	"./images/logo/dashboard-iknowa-logo.svg": 47295,
	"./images/logo/iknowa-black-beta.svg": 38129,
	"./images/logo/iknowa-card-logo.svg": 71313,
	"./images/logo/iknowa-logo-v4.svg": 98063,
	"./images/logo/iknowa-logo-v5.svg": 35486,
	"./images/logo/iknowa-logo-white-beta.svg": 49524,
	"./images/logo/iknowa-logo-white.svg": 97184,
	"./images/logo/iknowa-logo.svg": 85840,
	"./images/logo/iknowa-white-beta.svg": 86911,
	"./images/logo/logo.svg": 4692,
	"./images/map-marker.svg": 88622,
	"./images/media-chat-file-pdf.svg": 93630,
	"./images/media-chat-file-xls.svg": 33747,
	"./images/media-pdf.svg": 68068,
	"./images/media-xls.svg": 34089,
	"./images/no-content-placeholder.svg": 68274,
	"./images/no-property-placeholder.svg": 39832,
	"./images/not-fount.svg": 60574,
	"./images/payment-successful-icon.svg": 90044,
	"./images/pdf-icon.svg": 17423,
	"./images/people.svg": 51486,
	"./images/person.svg": 58300,
	"./images/phase-image-sample.svg": 27447,
	"./images/photo-placeholder.svg": 86745,
	"./images/pie-chart.svg": 74548,
	"./images/plumber.svg": 95524,
	"./images/po-banner.svg": 3999,
	"./images/project-bg.svg": 762,
	"./images/projects-tp-placeholder.svg": 37730,
	"./images/properties-bg.svg": 6920,
	"./images/property-add-property-illustration.svg": 62251,
	"./images/rating.svg": 45564,
	"./images/sample-graph-available-balance.svg": 42895,
	"./images/service_plan_modal.svg": 63504,
	"./images/site-visit-thumbnail.svg": 79563,
	"./images/star.svg": 18775,
	"./images/sticky-note.svg": 83619,
	"./images/tax-details.svg": 56139,
	"./images/team-performance-empty-thumbnail.svg": 47658,
	"./images/temporary-balance-image.svg": 76727,
	"./images/temporary-services-members.svg": 55599,
	"./images/temporary-services-projects.svg": 74136,
	"./images/temporary-services-storage.svg": 61085,
	"./images/temporary-services-transaction.svg": 65138,
	"./images/temporary-visa-card.svg": 95757,
	"./images/test.svg": 62843,
	"./images/tickmark.svg": 12091,
	"./images/tp-banner.svg": 98786,
	"./images/trades.svg": 76998,
	"./images/trash-red.svg": 89065,
	"./images/unverified-ws.svg": 93417,
	"./images/up-next-desktop.svg": 66065,
	"./images/up-next-mobile.svg": 43397,
	"./images/upcoming-events.svg": 94625,
	"./images/upload-image.svg": 18332,
	"./images/utility-coming-soon.svg": 56745,
	"./images/verify-account.svg": 13534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72193;